import { SwipeableDrawer as MobileDrawer } from '@mui/material';
import React from 'react';
import useBodyClass from '../../../hooks/useBodyClass';
import { useMenuItems } from '../../../hooks/useMenuItems';
import { Loading } from '../../../uikit';
import SidebarDrawerMobileContent from './SidebarDrawerMobileContent';

interface ISidebarDrawerProps {
  sidebarOpen: boolean;
  setSidebarOpen(open: boolean): void;
}

const SidebarDrawer: React.FC<ISidebarDrawerProps> = ({ sidebarOpen, setSidebarOpen }) => {
  const closeSidebar = () => setSidebarOpen(false);
  const openSidebar = () => setSidebarOpen(true);
  const { menuLinkItems, isLoading } = useMenuItems();

  useBodyClass({ className: 'sidebar-drawer-open', condition: sidebarOpen });

  return (
    <>
      <MobileDrawer anchor="left" sx={{ display: { xs: 'flex', md: 'none' } }} open={sidebarOpen} onClose={closeSidebar} onOpen={openSidebar}>
        {isLoading ? <Loading /> : <SidebarDrawerMobileContent setSidebarOpen={setSidebarOpen} menuItems={menuLinkItems} />}
      </MobileDrawer>
    </>
  );
};

export default SidebarDrawer;
